var map = {
	"./bank-alandsbanken.svg": 8336,
	"./bank-danskebank.svg": 8464,
	"./bank-handelsbanken.svg": 3322,
	"./bank-nordea.svg": 5139,
	"./bank-omasp.svg": 8038,
	"./bank-op.svg": 6907,
	"./bank-poppankki.svg": 1603,
	"./bank-saastopankki.svg": 4145,
	"./bank-spankki.svg": 4733,
	"./flag-dk.svg": 8757,
	"./flag-fi.svg": 7577,
	"./flag-no.svg": 1903,
	"./flag-se.svg": 9850,
	"./icon-arrow.svg": 5644,
	"./icon-back.svg": 9992,
	"./icon-card.svg": 2067,
	"./icon-checkmark.svg": 6964,
	"./icon-close.svg": 9439,
	"./icon-collectorbank-credit-warning.svg": 3277,
	"./icon-ctrl-q.svg": 1704,
	"./icon-date.svg": 2633,
	"./icon-edit.svg": 7281,
	"./icon-email.svg": 2791,
	"./icon-esc.svg": 4028,
	"./icon-info.svg": 7961,
	"./icon-input-checkmark.svg": 1360,
	"./icon-input-error.svg": 4546,
	"./icon-lock.svg": 4072,
	"./icon-phone-shake.svg": 3362,
	"./icon-phone-verified.svg": 2932,
	"./icon-phone.svg": 1671,
	"./icon-question.svg": 9113,
	"./icon-security-code.svg": 4659,
	"./icon-user-saved.svg": 6666,
	"./icon-warning-message.svg": 921,
	"./logo-worldline.svg": 3323,
	"./paymentcard-amex.svg": 5091,
	"./paymentcard-dankort.svg": 560,
	"./paymentcard-diners.svg": 5925,
	"./paymentcard-discover.svg": 2447,
	"./paymentcard-fbf.svg": 1300,
	"./paymentcard-jcb.svg": 115,
	"./paymentcard-maestro.svg": 5149,
	"./paymentcard-mastercard.svg": 8330,
	"./paymentcard-visa.svg": 525,
	"./paymenttype-applepay.svg": 2478,
	"./paymenttype-ekspresbank.svg": 243,
	"./paymenttype-googlepay.svg": 5137,
	"./paymenttype-mobilepay.svg": 6424,
	"./paymenttype-nordeaepaymentfi.svg": 5619,
	"./paymenttype-swish.svg": 3250,
	"./paymenttype-viabill.svg": 2603,
	"./paymenttype-vipps.svg": 7390,
	"./paymenttype-walley.svg": 8014
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5450;